<template>
  <div>
    <div class="common-seach-wrap">
      <el-form inline size="small"
        ><el-form-item label="标题"><el-input v-model="search.title" clearable /></el-form-item
        ><el-form-item label="状态"
          ><el-select v-model="search.status" clearable
            ><el-option
              v-for="option in statusOptions"
              :key="option.value"
              :label="option.label"
              :value="option.value" /></el-select></el-form-item
        ><el-button type="primary" @click="load(1)">查询</el-button
        ><span class="muted">选项在 设置 → 系统枚举 中维护（cooperation_*）</span></el-form
      >
    </div>
    <el-table :data="list" v-loading="loading"
      ><el-table-column prop="id" label="ID" width="90" /><el-table-column
        prop="title"
        label="合作标题"
        min-width="240"
      /><el-table-column prop="city_name" label="城市" width="110" /><el-table-column label="状态" width="100"
        ><template slot-scope="scope"
          ><el-tag :type="scope.row.status === 20 ? 'success' : 'info'">{{
            statuses[scope.row.status]
          }}</el-tag></template
        ></el-table-column
      ><el-table-column prop="review_note" label="审核意见" /><el-table-column label="操作" width="110"
        ><template slot-scope="scope"
          ><el-button type="text" @click="open(scope.row)">详情 / 审核</el-button></template
        ></el-table-column
      ></el-table
    >
    <el-pagination
      :current-page="search.page"
      :page-size="15"
      :total="total"
      layout="total, prev, pager, next"
      @current-change="load"
    />
    <el-dialog title="合作信息审核" :visible.sync="visible" width="780px" :close-on-click-modal="false">
      <div v-if="detail">
        <h3>{{ detail.payload.title }}</h3>
        <el-tag>{{ detail.status_text }}</el-tag>
        <div class="photos">
          <el-image
            v-for="file in detail.payload.image_files"
            :key="file.id"
            :src="file.url"
            fit="cover"
            :preview-src-list="detail.payload.image_files.map((item) => item.url)"
          />
        </div>
        <div class="facts">
          <p v-for="field in facts" :key="field.key">
            <b>{{ field.label }}：</b>{{ detail.payload.labels[field.key] }}
          </p>
        </div>
        <p><b>合作标签：</b>{{ detail.payload.labels.tags.join('、') }}</p>
        <p v-for="field in descriptions" :key="field.key" class="body">
          <b>{{ field.label }}：</b>{{ detail.payload[field.key] }}
        </p>
        <p><b>材料权限：</b>{{ detail.payload.labels.visibility }}</p>
        <div v-for="file in detail.payload.attachment_files" :key="file.id">
          <a :href="attachmentUrl(file)" target="_blank" rel="noopener">{{ file.name }}</a>
        </div>
        <h4>收到的合作申请</h4>
        <el-table :data="detail.applications" size="mini"
          ><el-table-column prop="contact_name" label="联系人" /><el-table-column
            prop="contact_phone"
            label="手机号" /><el-table-column prop="message" label="合作意向"
        /></el-table>
        <h4>审核记录</h4>
        <el-table :data="detail.audit_logs" size="mini"
          ><el-table-column prop="operator_id" label="操作人ID" /><el-table-column label="结果"
            ><template slot-scope="scope">{{ statuses[scope.row.to_status] }}</template></el-table-column
          ><el-table-column prop="note" label="意见"
        /></el-table>
        <el-input
          v-if="detail.status === 10 || detail.status === 20"
          v-model="note"
          type="textarea"
          :rows="3"
          maxlength="500"
          placeholder="审核意见（驳回、下架必须填写原因）"
          class="review-note"
        />
      </div>
      <div slot="footer">
        <el-button @click="visible = false">关闭</el-button
        ><el-button v-if="detail && detail.status === 10" type="danger" :disabled="saving" @click="review(30)"
          >驳回</el-button
        ><el-button v-if="detail && detail.status === 10" type="primary" :loading="saving" @click="review(20)"
          >审核通过并公开</el-button
        ><el-button v-if="detail && detail.status === 20" type="warning" :loading="saving" @click="review(40)"
          >下架</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>
<script>
import request from '@/utils/request';
export default {
  data() {
    return {
      list: [],
      total: 0,
      loading: false,
      saving: false,
      visible: false,
      detail: null,
      note: '',
      statuses: {},
      search: { page: 1, title: '', status: '' },
      statusOptions: [
        { value: 10, label: '审核中' },
        { value: 20, label: '已发布' },
        { value: 30, label: '未通过' },
        { value: 40, label: '已下架' },
      ],
      facts: [
        { key: 'type', label: '合作类型' },
        { key: 'city', label: '城市' },
        { key: 'industry', label: '所属行业' },
        { key: 'scale', label: '合作规模' },
        { key: 'period', label: '合作周期' },
      ],
      descriptions: [
        { key: 'provided', label: '我方提供' },
        { key: 'expected', label: '期待伙伴' },
        { key: 'description', label: '合作说明' },
      ],
    };
  },
  created() {
    this.load(1);
  },
  methods: {
    load(page) {
      this.loading = true;
      this.search.page = page || 1;
      request
        ._get('shop/issueorder.cooperationv2/index', this.search)
        .then((res) => {
          this.list = res.data.list.data;
          this.total = res.data.list.total;
          this.statuses = res.data.statuses;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    open(row) {
      request._get('shop/issueorder.cooperationv2/detail', { id: row.id }).then((res) => {
        this.detail = res.data;
        this.note = '';
        this.visible = true;
      });
    },
    attachmentUrl(file) {
      return (
        '/index.php/shop/issueorder.cooperationv2/attachment?id=' + this.detail.id + '&asset_id=' + file.id
      );
    },
    review(status) {
      if (this.saving) return;
      if (status !== 20 && !this.note.trim()) return this.$message.error('请填写原因');
      this.$confirm(status === 20 ? '审核通过后将公开展示，确认继续？' : '确认保存审核结果？', '合作审核')
        .then(() => {
          this.saving = true;
          return request
            ._post('shop/issueorder.cooperationv2/review', {
              id: this.detail.id,
              revision: this.detail.revision,
              status,
              note: this.note,
            })
            .then(() => {
              this.$message.success('已保存');
              this.visible = false;
              this.load(this.search.page);
            })
            .finally(() => {
              this.saving = false;
            });
        })
        .catch(() => {});
    },
  },
};
</script>
<style scoped>
.muted {
  color: #909399;
  font-size: 12px;
}
.photos {
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
  margin: 16px 0;
}
.photos .el-image {
  width: 140px;
  height: 95px;
  border-radius: 6px;
}
.facts {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 0 15px;
}
.body {
  white-space: pre-wrap;
  line-height: 1.8;
}
.review-note {
  margin-top: 20px;
}
.el-pagination {
  margin-top: 20px;
}
</style>



// WEBPACK FOOTER //
// src/views/issueorder/cooperationv2/index.vue